module.exports = __webpack_public_path__ + "img/main-desk.fdf65999.jpg";